import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false, 
  loading: false,
  error: null,
};

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const contactFormsReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.CONTACT_FORMS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.CONTACT_FORMS_READ_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.CONTACT_FORMS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const contactFormReducer = (state = initialStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.CONTACT_FORM_READ_BEGIN:
      return {
        ...initialStateSingle,
        loading: true,
      };

    case actions.CONTACT_FORM_READ_SUCCESS:
      return {
        ...initialStateSingle,
        data,
        error: false,
        loading: false,
      };

    case actions.CONTACT_FORM_READ_ERR:
      return {
        ...initialStateSingle,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { contactFormsReducer, contactFormReducer };
